import { render, staticRenderFns } from "./edit-page.vue?vue&type=template&id=eb6ed66e&scoped=true&"
import script from "./edit-page.vue?vue&type=script&lang=js&"
export * from "./edit-page.vue?vue&type=script&lang=js&"
import style0 from "./edit-page.vue?vue&type=style&index=0&id=eb6ed66e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6ed66e",
  null
  
)

export default component.exports